import { usePremiumCurrencyFormatter } from '@wix/premium-react-text';
import * as React from 'react';
import { Translation, Trans } from 'react-i18next';
import { Text } from 'wix-style-react';
import { CycleMultiplier } from '../../../../../constants';
import { ChangePlanPlanDetails } from '../../../ChangePlanTypes';
import classNames from 'classnames';
import s from '../ChangePlanModal.scss';
import { PaymentCycle } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';

interface PlanDetailsProps {
  rootStore: RootStore;
  planDetails: ChangePlanPlanDetails;
  showUnpaidMsg: boolean;
  showDiscountMsg: boolean;
  isCurrentPlan: boolean;
}

const PlanDetailsComp: React.FC<PlanDetailsProps> = ({
  rootStore,
  planDetails,
  showUnpaidMsg,
  showDiscountMsg,
  isCurrentPlan,
}) => {
  const { isDowngradePlanOfDeclineChargeService } = rootStore.appStore;
  const [currencyToString] = usePremiumCurrencyFormatter();
  return (
    <Translation>
      {(t) => (
        <div className={s.planDetails}>
          <Text className={s.planName} weight='bold'>
            {planDetails.localizedProductName}
          </Text>
          <Text size='small'>
            {planDetails.paymentCycle !== PaymentCycle.MONTHLY ? (
              <Trans
                i18nKey='change_plan.change_plan_modal.plan_price'
                values={{
                  fullPrice: currencyToString(planDetails.totalPrice),
                  pricePerMonth: currencyToString(planDetails.pricePerMonth),
                  numberOfMonths: CycleMultiplier[planDetails.paymentCycle],
                }}
              >
                <Text size='small'>boldprice</Text>
              </Trans>
            ) : (
              <Text>
                {t('change_plan.change_plan_modal.plan_price_monthly', {
                  pricePerMonth: currencyToString(planDetails.pricePerMonth),
                })}
              </Text>
            )}
          </Text>
          {showDiscountMsg && (
            <Text
              size='small'
              weight='bold'
              className={classNames(s.badge, {
                [s.discount]: isCurrentPlan,
              })}
              data-testid='discounted_price'
            >
              {!!planDetails.discountedPrice &&
                t('change_plan.change_plan_modal.discounted_price', {
                  discountedPrice: currencyToString(
                    planDetails.discountedPrice,
                  ),
                })}
            </Text>
          )}
          {showUnpaidMsg && (
            <div
              className={classNames(s.badge, {
                [s.unpaidBadge]: isCurrentPlan,
              })}
            >
              {isCurrentPlan && (
                <Text
                  weight='bold'
                  light={true}
                  data-testid='unpaid'
                  className={s.unpaid}
                >
                  {isDowngradePlanOfDeclineChargeService
                    ? t('change_plan.change_plan_modal.payment_problem')
                    : t('change_plan.change_plan_modal.unpaid').toUpperCase()}
                </Text>
              )}
            </div>
          )}
        </div>
      )}
    </Translation>
  );
};

export const PlanDetails = withInjectedRootStore(PlanDetailsComp);
